import { Temporal } from 'temporal-polyfill';

export const START_DATE_CUTOFF_IN_MONTHS = 13;

export const getMinAllowedDate = (): Temporal.PlainDate => {
  const today = Temporal.Now.plainDateISO();
  return today.subtract({ months: START_DATE_CUTOFF_IN_MONTHS });
};
